import React from 'react';

import { Icon } from '@rbilabs/components-library';
import styled from 'styled-components';

import { CardTypes } from 'state/payment/types';
import { mapPaymentMethodCardTypes } from 'utils/payment/map-payment-method-card-type';

const BlankCard = styled.div`
  background-color: ${Styles.color.grey.four};
  height: 1.2rem;
  width: 1.6rem;
`;

export const cardIconRenderer = (methodType: string): JSX.Element => {
  const cardType = mapPaymentMethodCardTypes(methodType);
  if (!cardType) {
    return <BlankCard />;
  }

  return {
    [CardTypes.VISA]: <Icon title={'Visa'} icon="visa" color="primary" />,
    [CardTypes.MASTERCARD]: <Icon title={'Mastercard'} icon="mastercard" color="primary" />,
    [CardTypes.AMEX]: <Icon title={'Amex'} icon="amex" color="primary" />,
    [CardTypes.DISCOVER]: <Icon title={'Discover'} icon="discover" color="primary" />,
    [CardTypes.APPLE_PAY]: <Icon title={'Apple Pay'} icon="applepay" color="primary" />,
    [CardTypes.GOOGLE_PAY]: <Icon title={'Google Pay'} icon="googlePay" color="primary" />,
    [CardTypes.PAYPAL]: <Icon title={'PayPal'} icon="paypal" color="primary" />,
  }[cardType];
};
